export default __webpack_public_path__ + "static/media/wallet-bucks-icon.c632b89b.png";